// src/js/components/fam-colabora-item.js

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-colabora-item]").forEach((wrap) => {
    const card = wrap.querySelector(".js-colabora-card");
    if (!card) return;

    const titleEl = card.querySelector(".js-colabora-title");
    const subtitleEl = card.querySelector(".js-colabora-subtitle");
    const imgEl = card.querySelector(".js-colabora-img");
    const bodyEl = card.querySelector(".js-colabora-body");
    
    // Configuraciones por data-attributes
    const title = wrap.dataset.title || "";
    const subtitle = wrap.dataset.subtitle || "";
    const reverse = wrap.dataset.reverse === "true";
    
    // Nodos de contenido HTML aportados por el usuario
    const contentSrc = wrap.querySelector(".js-colabora-content");
    const imageSrc = wrap.querySelector("img.js-colabora-asset");

    // Inyectar Textos
    if (titleEl) titleEl.textContent = title;
    if (subtitleEl) subtitleEl.textContent = subtitle;
    
    // Inyectar Imagen
    if (imgEl && imageSrc) {
      imgEl.src = imageSrc.src;
      imgEl.alt = title;
    } else if (imgEl) {
      imgEl.style.display = 'none';
      card.querySelector('.lg\\:w-2\\/5').style.display = 'none';
      card.querySelector('.lg\\:w-3\\/5').classList.remove('lg:w-3/5', 'xl:w-7/12');
      card.querySelector('.lg\\:w-3\\/5').classList.add('w-full');
    }

    // Inyectar Cuerpo HTML
    if (bodyEl && contentSrc) {
      bodyEl.innerHTML = contentSrc.innerHTML;
    }

    // Gestionar Reverso para layout intercalado
    if (reverse) {
      card.classList.remove("lg:flex-row");
      card.classList.add("lg:flex-row-reverse");
    }
  });
});
